var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLeftTriangle = function SvgLeftTriangle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137-10.52v149.16a8 8 0 0 1-.5-.58L82.77 69.4a8 8 0 0 1-.03-9.82L136.47-9.9c.17-.22.35-.42.53-.62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLeftTriangle);
export default ForwardRef;